import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Extrude from '../../extrude.js';
import Spline from '../spline.js';

export default class NodeLathe extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'shape', null);
		this.addInput(PARAM_TYPE.FLOAT, 'axis_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'smooth_angle', 0.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'start_angle', 0, { minValue: 0, maxValue: 360, units: PARAM_UNITS.DEGREES });
		this.addInput(PARAM_TYPE.FLOAT, 'end_angle', 360, { minValue: 0, maxValue: 360, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'roughness', 0.01, { minValue: 0.001, maxValue: 0.2 });

		this.addInput(PARAM_TYPE.BOOLEAN, 'cap', true);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'lathe';
	}

	getAllowResultCachingSubclass()
	{
		return true;
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let listShape = inputValues['shape'];
		if(!listShape || listShape.points.length < 2)
			return null;

		let pShapeSpline = new Spline(listShape);
		if(pShapeSpline.getIs3D())
			throw Error('Extrusion shape must be a 2D spline - it is currently 3D.');

		let fExtraOffset = inputValues['axis_offset'];

		let shapeBBox = pShapeSpline.getBBox();
		if(inputValues['cap'])
		{
			// Now, add segments that stretch to the origin:
			pShapeSpline.setIsClosed(false);
			let vecCenter = shapeBBox.max.add(shapeBBox.min).scale(0.5);
			if(vecCenter.x < 0)
				pShapeSpline.translate(-fExtraOffset, 0);
			else
				pShapeSpline.translate(fExtraOffset, 0);
			fExtraOffset = 0;

			if(Math.abs(pShapeSpline.points[0].point.x) > 1e-4)
				pShapeSpline.insertPoint(0, new BABYLON.Vector2(0, pShapeSpline.points[0].point.y));
			let iNumPoints = pShapeSpline.points.length;
			if(Math.abs(pShapeSpline.points[iNumPoints - 1].point.x) > 1e-4)
				pShapeSpline.insertPoint(iNumPoints, new BABYLON.Vector2(0, pShapeSpline.points[iNumPoints - 1].point.y));
		}

		shapeBBox = pShapeSpline.getBBox();
		let vecSize = shapeBBox.max.subtract(shapeBBox.min);

		let fRadius = vecSize.x - vecSize.x/2.0 + fExtraOffset;

		let pPathSpline = Spline.createArc(fRadius, fRadius, inputValues['start_angle'], inputValues['end_angle'], null, inputValues['roughness']);

		let bClose = false;
		let capType = BABYLON.Mesh.CAP_ALL;
		if(inputValues['end_angle'] - inputValues['start_angle'] >= 360)
		{
			bClose = true;
			capType = BABYLON.Mesh.NO_CAP;
		}			

		pShapeSpline.rotate(-90);
		
		let vecShapePoints = pShapeSpline.getLinearPoints(true);

		let pMesh = Extrude.createMesh(this.getGeneratedMeshName(), {
				shape: vecShapePoints,
				path: pPathSpline, 
				extrusionPlane: 'xz',
				close: bClose,
				cap: capType,
				uOffset: 0,
				vOffset: 0,
				uvRotation: 0,
				flatShaded: true,
				smoothAngle: inputValues['smooth_angle'],
			}, scene);

		if(!pMesh)
			return null;

		this.onMeshCreated(pMesh);

		//this.createAndAssignMaterial(pMesh, scene);
		pMesh.position = new BABYLON.Vector3(0, 0, 0);

		return [pMesh]; 
	}
}